var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgDragIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 5,
    viewBox: "0 0 14 5",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 5V3.33333H13.3333V5H0ZM0 1.66667V0H13.3333V1.66667H0Z",
    fill: "#99B2C6"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgDragIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/drag-icon.d6a1f217efd8af602c66e84e049829e2.svg";